import { ReadonlyArray } from "@morphism/fp";
import * as Ant from "antd";
import React from "react";

import { DVIR, DVIRs } from "~/DVIR";
import { Order } from "~/Order";

export function Type({ dvir }: { readonly dvir: DVIR }) {
  return <>{DVIR.Type.toString(dvir)}</>;
}

export namespace Type {
  export const column = ({
    types,
    onChange,
  }: {
    readonly types?: readonly DVIR.Type[];
    readonly onChange: (types?: readonly DVIR.Type[]) => void;
  }) => ({
    title: "Type",
    dataIndex: "type",

    filteredValue: types?.[0] && ["types"],
    filterDropdown: (props: { readonly confirm: () => void }) => (
      <Filter {...{ types, onChange }} {...props} />
    ),
    onFilter: (_: unknown, dvir: DVIR) => pipe(dvir, getFilterFunc(types)),
    render: (_: unknown, dvir: DVIR) => <Type dvir={dvir} />,
    sorter: (a: DVIR, b: DVIR): Order.Ordering =>
      Order.string().compare(DVIR.Type.toString(a), DVIR.Type.toString(b)),
  });

  export const getFilterFunc = (types: readonly DVIR.Type[] = []) => (
    dvir: DVIR
  ) =>
    types.length ? types.map(({ type }) => type).includes(dvir.type) : true;

  export const getFilterFuncForSettings = (settings: DVIRs.Table.Settings) =>
    getFilterFunc(settings.types);

  export const Filter = ({
    types,
    onChange,
    confirm,
  }: DVIRs.Table.Filter.Props & Parameters<typeof column>[0]) =>
    pipe(
      DVIR.Types.list(),
      ReadonlyArray.map(({ type }) => (
        <div key={type}>
          <Ant.Checkbox
            checked={types?.map(({ type }) => type).includes(type)}
            onChange={(event) =>
              onChange(
                event.target.checked
                  ? [...(types ?? []), { type }]
                  : (types ?? []).filter(
                      ({ type: selected }) => selected !== type
                    )
              )
            }
          >
            {DVIR.Type.toString({ type })}
          </Ant.Checkbox>
        </div>
      )),
      (checkboxes) => (
        <DVIRs.Table.Filter confirm={confirm} onReset={types?.[0] && onChange}>
          {checkboxes}
        </DVIRs.Table.Filter>
      )
    );
}
